import { setupDynamicRoutes } from "@main/router/guards";
import { message } from "ant-design-vue";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { login, toggleBusiness, type LoginResponseData } from "@/services/login";
import { useAppTabsStore } from "./useAppTabsStore";
import { useUserRoleStore } from "./useUserRoleStore";

export const useUserStore = defineStore(
	"user",
	() => {
		const router = useRouter();
		const userRoleStore = useUserRoleStore();
		const appTabsStore = useAppTabsStore();

		const userInfo = ref<LoginResponseData>();

		const loginWithVerificationCode = async (data: { mobile: string; code: string }) => {
			const res = await login({
				action: "mobile",
				...data,
			});

			if (res.code === window.$config.successCode) {
				userInfo.value = res.data;
				localStorage.setItem("token", res.data.token);
				message.success("登录成功");
				userRoleStore.getAdminMenuList();

				setTimeout(() => {
					router.replace("/desktopCenter");
				}, 200);
			}
		};

		const loginWithAccount = async (data: { username: string; password: string }) => {
			const res = await login({
				...data,
				action: "account",
			});

			if (res.code === window.$config.successCode) {
				userInfo.value = res.data;
				localStorage.setItem("token", res.data.token);
				message.success("登录成功");
				userRoleStore.getAdminMenuList();

				setTimeout(() => {
					router.replace("/desktopCenter");
				}, 200);
			}
		};

		const switchOrganization = async (id: number, showMessage = true) => {
			const res = await toggleBusiness({ choose_company_id: id });

			if (res.code === window.$config.successCode) {
				userInfo.value = res.data;
				localStorage.setItem("token", res.data.token);
				await userRoleStore.getAdminMenuList();

				const switchToDesktopCenter = async () => {
					const currentFullPath = router.currentRoute.value.fullPath;

					await setupDynamicRoutes(router);

					const resolved = router.resolve(currentFullPath);

					if (resolved.matched.length === 0 || resolved.name === "NotFound") {
						appTabsStore.clearTabs();
						await router.replace("/desktopCenter");

						return;
					}

					await router.replace(currentFullPath);
				};

				if (showMessage) {
					message.success("切换成功");
				}

				await switchToDesktopCenter();
			}
		};

		return {
			userInfo,
			loginWithVerificationCode,
			loginWithAccount,
			switchOrganization,
		};
	},
	{
		// 开启数据持久化
		persist: [
			{
				storage: localStorage,
			},
		],
	}
);
